import(/* webpackMode: "eager" */ "/home/i2k2admin/RestroAgent/RestroAgent/src/app/(landing)/terms/page.tsx");
